// extracted by mini-css-extract-plugin
module.exports = {"scrollableContainer":"installed-apps-list_scrollableContainer_cIB8U","app":"installed-apps-list_app_3FxrI"};